/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'zoom-in-map': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M1 .25A.747.747 0 00.25 1v8a.75.75 0 001.5 0V1.75H9a.75.75 0 000-1.5H1zm22 23.5a.75.75 0 00.75-.75v-8a.75.75 0 00-1.5 0v7.25H15a.75.75 0 100 1.5h8zm0-23.5a.764.764 0 01.153.016.75.75 0 01.597.734v8a.75.75 0 01-1.5 0V1.75H15a.75.75 0 010-1.5h8zM.266 23.151A.75.75 0 001 23.75h8a.75.75 0 000-1.5H1.75V15a.75.75 0 00-1.5 0v8c0 .052.006.102.016.151z" _fill="#000"/>'
  }
})
